/**
 * Handles the plp lazy loading and back button functionality
 * Lazy loads the images once window loads.
 * Fixes the correct page position if going back to plp.
 * @module sizeSelection
 */

import $ from 'jquery';
import registerJQueryPlugin from 'styleguide/lib/register-jquery-plugin';
import mergeOptions from 'styleguide/lib/merge-options'
import Keyboard from 'styleguide/modules/keyboard';

export const PLUGIN_NAME = 'sizeSelection';
export const SS_MENU_CLASS = '.js-select-size-menu';
export const SS_TRIGGER_CLASS = '.js-select-size-trigger';

export const DEFAULTS = {
    animationSpeed: 100,
};

/**
 * Prevent Hash
 * @param  {event} interaction event
 * @param  {jQuery} $ddTrigger - dropdown trigger element
 */
 const preventHash = (evt, $saveSizeTrigger) => {
    if(Keyboard.parseKey(evt) === 'ENTER' || evt.type == 'click') {
      if($saveSizeTrigger.attr('href') == "#") {
        evt.preventDefault();
      }
    }
  };

const setLoading = ($el) => {
    $el.closest('.js-product-info-block').append(progressBarHTML());
}
const removeLoading = ($el) => {
    $el.closest('.js-product-info-block').find('.plp__size-loading').remove();
}

const progressBarHTML = () => {
    return `<div class="plp__size-loading">
        <div class="u-padding-a--xl">
                <div class="progress-bar progress-bar--dark">
                    <div class="u-screen-reader">
                        Content is Loading
                    </div>
                </div>
            </div>
        </div>`
  }

const openSizes = ($el, $saveSizeTrigger, $saveSizeMenu, opts) => {
    $el.addClass('ss-is-open');
    $saveSizeMenu.css({display:'block', opacity:0}).stop().animate({
        opacity: 1,
      }, opts.animateSpeed, () => {
      });
    setClickCloseListener($el, $saveSizeTrigger, $saveSizeMenu, opts);
}

const closeSizes = ($el, $saveSizeMenu, opts) => {
    $el.removeClass('ss-is-open');
    $el.find('input[type=radio][name=fav-size-selection]').off('change.size');
    $(document).off('click.close');
    $saveSizeMenu.stop().animate({
        opacity: 0,
      }, opts.animateSpeed / 2, () => {
        $saveSizeMenu.css('display', 'none');
      });
}

const showConfirmation = ($saveSizeTrigger, opts, hasError) => {
    const {saveSizeConfirmPath} = opts;
    $.modal({
        url: `${saveSizeConfirmPath}${hasError}`,
        type: 'notification',
        triggerOpen: true,
        returnFocus: $saveSizeTrigger,
    }) 
}

const updateSizeCopy = ($el, $saveSizeTrigger, sizeValue, opts) => {
    let {code} = opts;
    if ($saveSizeTrigger.data('code')) {
        code = $saveSizeTrigger.data('code')
    }
    const hideClass = opts.hideCopy ? "class=\"u-hide\"" : "";
    $saveSizeTrigger.html(`<span id="${code}-fav-size-value" data-size="${sizeValue}" ${hideClass}>Size: ${sizeValue}</span>`);
    const $soldOut = $el.find('.js-saved-size-sold-out');
    if ($soldOut.length) {
        $soldOut.hide();
    }
}

const keydownHandler = ($el, evt, $saveSizeTrigger, opts, isKey) => {
        const isTab = Keyboard.parseKey(evt) === 'TAB';
        const isShiftTab = Keyboard.parseKey(evt) === 'SHIFT_TAB';
        const isEnter = Keyboard.parseKey(evt) === 'ENTER';
        const isNextArrows = Keyboard.parseKey(evt) === 'ARROWRIGHT' || Keyboard.parseKey(evt) === 'ARROWDOWN';
        const isPrevArrows = Keyboard.parseKey(evt) === 'ARROWLEFT' || Keyboard.parseKey(evt) === 'ARROWUP';
        const sizeHaveFocus = $el.find('input[type=radio]').is(":focus");
    if (isEnter) {
        if (!$el.hasClass('ss-is-open')) {
            evt.preventDefault();
            getSizes($el, $saveSizeTrigger, opts, isKey);
        }
        if(sizeHaveFocus) {
            const sizeIsChecked = $(evt.target).is(':checked');
            const sizeValue = $(evt.target).prop('value');
            if(!sizeIsChecked) {
                updateSizeCopy($el, $saveSizeTrigger, sizeValue, opts)
            }
            const $saveSizeMenu = $el.find(SS_MENU_CLASS);
            updateSizeToDb($el, $saveSizeTrigger, $saveSizeMenu, opts, sizeValue);
        }
    }
    if((isNextArrows || isPrevArrows) && sizeHaveFocus) {
        const $saveSizeMenu = $el.find(SS_MENU_CLASS);
        setUpdateSizeListener($el, $saveSizeTrigger, $saveSizeMenu, isKey, opts);
    }
    if ((isTab || isShiftTab) && sizeHaveFocus) {
        const $saveSizeMenu = $el.find(SS_MENU_CLASS);
        closeSizes($el, $saveSizeMenu, opts);
    }
}

const setUpdateSizeListener = ($el, $saveSizeTrigger, $saveSizeMenu, isKey, opts) => {
    $el.find('input[type=radio]').on('change.size', function(evt) {
        const sizeValue = $(this).prop('value');
        const isOneLeft = $(this).data('isOneLeft');
        updateSizeCopy($el, $saveSizeTrigger, sizeValue, opts);

        const {addToBag, code} = opts;
        const $soldOut = $el.find('.js-saved-size-sold-out');
        const $oneLeft = $el.find('.js-saved-size-one-left');
        if ($soldOut.length) {
            $soldOut.hide();
        }
        if (isOneLeft !== undefined && $oneLeft.length) {
            if (isOneLeft) {
                $oneLeft.show();
            } else {
                $oneLeft.hide();
            }
        }
        if(!isKey) {
            updateSizeToDb($el, $saveSizeTrigger, $saveSizeMenu, opts, sizeValue);
        }
        if (addToBag === 'true') {
            const $addToBag = $(`#addToBag_${code}`);
            if ($addToBag.length) {
                $addToBag.click();
            }
        }
    })
}

const updateSizeToDb = ($el, $saveSizeTrigger, $saveSizeMenu, opts, sizeValue) => {
    const saveSize = $el.data('saveSize');
    if (sizeValue && saveSize) {
        const {updateSizePath, code} = opts;
        setLoading($el);
        $.ajax({
            url: `${updateSizePath}${sizeValue}`,
            type: "POST",
            success: function (ret) {
                removeLoading($el);
                if (ret.success) {
                    closeSizes($el, $saveSizeMenu, opts);
                    const $preorderCta = $(`#preorder-cta-${code}`);
                    const $addToBagCta = $(`#add-to-bag-cta-${code}`);
                    const $addToBagBtn = $(`#addToBag_${code}`);
                    const $outOfStockBtn = $(`#outOfStock_${code}`);
                    if ($outOfStockBtn.length) {
                        $addToBagBtn.show();
                        $outOfStockBtn.remove();
                    }
                    if (ret.isPreorder) {
                        $preorderCta.show();
                        $addToBagCta.hide();
                    } else {
                        $preorderCta.hide();
                        $addToBagCta.show();
                    }
                    showConfirmation($saveSizeTrigger, opts, false);
                    if(typeof logEngagementWithDetails === "function") {
                        logEngagementWithDetails(window.location.href, 'favorites save your size', 'SaveSize', `size=${sizeValue}, code=${code}`);
                    }
                }
            }
        });
    } else {
        closeSizes($el, $saveSizeMenu, opts);
    }
}

const setClickCloseListener = ($el, $saveSizeTrigger, $saveSizeMenu, opts) => {
    $(document).on('click.close',function(e) {
        const $sizeMenu = $el.find('.js-select-size-menu');
        const notSizeMenu = !$sizeMenu.is(e.target);
        const notSizeOption = $sizeMenu.has(e.target).length === 0;
        const notTriggerBtn = e.target !== $saveSizeTrigger[0];

        if (notSizeMenu && notSizeOption && notTriggerBtn) {
            closeSizes($el, $saveSizeMenu, opts);
        }
    })
}


const getSizes = ($el, $saveSizeTrigger, opts, isKey) => {
    const {sizePath} = opts;
    $(".js-select-size-menu").remove();
    opts.addToBag = $saveSizeTrigger.data('addToBag');
    $saveSizeTrigger.data('addToBag', 'false');
    setLoading($el);
    $.ajax({
        url: `${sizePath}`,
        type: "GET",
        success: function (sizePopupMarkup) {
            removeLoading($el);
            $saveSizeTrigger.after(sizePopupMarkup);
            const $saveSizeMenu = $el.find(SS_MENU_CLASS);
            openSizes($el, $saveSizeTrigger, $saveSizeMenu, opts);
            if(!isKey) {
                setUpdateSizeListener($el, $saveSizeTrigger, $saveSizeMenu, isKey, opts);
            }
        }
    });
}


/**
 * Applies any sort of event handlers for the switchClass.
 * @param  {jQuery} $el - link
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
const setEventListeners = ($el, $saveSizeTrigger, opts) => {
    
    $el
    .on('keydown',(evt) => {
        keydownHandler($el, evt, $saveSizeTrigger, opts, true);
    });
    $saveSizeTrigger.on('click', (evt) => {
        evt.preventDefault();
        getSizes($el, $saveSizeTrigger, opts, false);
    });
    $saveSizeTrigger.on('keydown', (evt) => {
        preventHash(evt, $saveSizeTrigger);
    });
};

/**
 * Initializes sizeSelection.
 * @param {jQuery} el - targeting the element of the plp list
 * @param {Object} options - Options used for wiring up the sizeSelection
 * @see DEFAULTS
 */
export default function sizeSelection(el, options = {}) {
    const $el = $(el);
    const opts = mergeOptions(DEFAULTS, options, $el);
    const $saveSizeTrigger = $el.find(SS_TRIGGER_CLASS);
    setEventListeners($el, $saveSizeTrigger, opts);
}

registerJQueryPlugin(PLUGIN_NAME, sizeSelection);



// WEBPACK FOOTER //
// ./src/scripts/entry-points/plp/size-selection.js